import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const SalesForecastNextQtrPlus1Paper = ({
  classes,
  paperTitle,
  salesForecastNextQuarterPlus1Data,
  isSalesForecastNextQuarterPlus1Loading,
  salesForecastNextQuarterPlus1Columns,
  salesForecastNextQuarterPlus1Rows,
  getCellValue,
  handleChangeLocation,
  createSummaryTableColumns,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Typography variant="h6" className={classes.title}>
            Sales Forecast – Next Quarter +1
            {salesForecastNextQuarterPlus1Data?.targetQuarter
              ? ` (${salesForecastNextQuarterPlus1Data.targetQuarter})`
              : ""}
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        {isSalesForecastNextQuarterPlus1Loading ? (
          <Skeleton variant="rect" animation="wave" height={200} width="100%" />
        ) : (
          <>
            {/* Summary */}
            <Box mb={2}>
              <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                Summary
              </Typography>
              <ResizableTable
                columns={createSummaryTableColumns(currencySymbol)}
                rows={[
                  {
                    label: "Won QTD",
                    count:
                      salesForecastNextQuarterPlus1Data?.summary?.won?.count ||
                      0,
                    acvInMillions:
                      salesForecastNextQuarterPlus1Data?.summary?.won
                        ?.acvInMillions || "0.00",
                    rowType: "won",
                  },
                  {
                    label: "Most Likely + Commit",
                    count:
                      salesForecastNextQuarterPlus1Data?.summary?.forecast
                        ?.count || 0,
                    acvInMillions:
                      salesForecastNextQuarterPlus1Data?.summary?.forecast
                        ?.acvInMillions || "0.00",
                    rowType: "forecast",
                  },
                  {
                    label: "Total Forecast",
                    count:
                      salesForecastNextQuarterPlus1Data?.summary?.total
                        ?.count || 0,
                    acvInMillions:
                      salesForecastNextQuarterPlus1Data?.summary?.total
                        ?.acvInMillions || "0.00",
                    rowType: "total",
                  },
                  {
                    label: "Forecast Goal (1.5x Quota)",
                    count: "",
                    acvInMillions:
                      salesForecastNextQuarterPlus1Data?.summary
                        ?.forecastGoal || "0.00",
                    rowType: "forecast",
                  },
                  {
                    label: "Quota",
                    count: "",
                    acvInMillions:
                      salesForecastNextQuarterPlus1Data?.summary
                        ?.quotaInMillions || "0.00",
                    rowType: "quota",
                  },
                ]}
                getCellValue={(row, field) => {
                  if (field === "label") {
                    return row[field];
                  }
                  return row[field] != null ? row[field] : "";
                }}
                getCellStyle={(row, field) => {
                  const baseStyle = {};
                  if (field === "label") {
                    baseStyle.fontWeight = 600;
                  }
                  if (row.rowType === "total") {
                    baseStyle.backgroundColor = "#f5f5f5";
                    if (field === "count" || field === "acvInMillions") {
                      baseStyle.fontWeight = 600;
                    }
                  }
                  if (row.rowType === "quota") {
                    baseStyle.backgroundColor = "#fff9c4";
                    if (field === "acvInMillions") {
                      baseStyle.fontWeight = 600;
                    }
                  }
                  return baseStyle;
                }}
                rowKey="label"
                hideSubHeaderRow={true}
                maxWidth="34%"
              />
            </Box>

            {/* Forecast Opps Table */}
            <Box mb={3}>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 600, marginTop: 70 }}
              >
                Sales Forecast – Next Quarter +1
                {salesForecastNextQuarterPlus1Data?.targetQuarter
                  ? ` (${salesForecastNextQuarterPlus1Data.targetQuarter})`
                  : ""}{" "}
                – Opps in Forecast – Most Likely + Commit
              </Typography>
              {!salesForecastNextQuarterPlus1Data?.forecastOpps ||
              salesForecastNextQuarterPlus1Data.forecastOpps.length === 0 ? (
                <Box
                  textAlign="center"
                  py={4}
                  style={{ fontStyle: "italic", color: "#666" }}
                >
                  No forecast opportunities for next quarter +1
                </Box>
              ) : (
                <ResizableTable
                  columns={salesForecastNextQuarterPlus1Columns}
                  rows={salesForecastNextQuarterPlus1Rows}
                  getCellValue={getCellValue}
                  getCellStyle={(row, field) => {
                    if (row.label === "Total" || row.label === "Quota") {
                      return {
                        fontWeight: 600,
                        backgroundColor:
                          row.label === "Quota" ? "#fff9c4" : "#f5f5f5",
                      };
                    }
                    if (row.isNewThisWeek) {
                      return { backgroundColor: "#c8e6c9" };
                    }
                    return {};
                  }}
                  rowKey="label"
                  hideSubHeaderRow={true}
                  maxWidth="100%"
                  onRowClick={(row) =>
                    handleChangeLocation(
                      "drilldownOnGraph",
                      row,
                      "nextQuarterPlus1",
                    )
                  }
                />
              )}
            </Box>

            {/* Legend for green highlighting */}
            <Box mt={2}>
              <div className={classes.legend}>
                <div className={classes.legendItem}>
                  <div
                    className={classes.legendBox}
                    style={{ backgroundColor: "#c8e6c9" }}
                  />
                  <Typography variant="body2">New this week</Typography>
                </div>
              </div>
            </Box>
          </>
        )}
      </Paper>
    </Grid>
  );
};

export default SalesForecastNextQtrPlus1Paper;
